
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import BasePill from "./BasePill.vue";

@Component({
  name: "BaseTeamCard",
  components: {
    BasePill,
  },
})
export default class BaseTeamCard extends Vue {
  @Prop({ default: 46 }) size!: number;

  @Prop({ default: "grey lighten-2" }) colorClass!: string;

  @Prop({ default: "Team name" }) teamName!: string;

  @Prop({ default: "300" }) cardWidth!: string;

  @Prop({ default: "85" }) cardHeight!: string;

  @Prop({ default: "fas fa-user-friends" }) faIcon!: string;

  @Prop({ default: "fa fa-user" }) personIcon!: string;

  @Prop({ default: "fa fa-cog" }) ticketIcon!: string;

  @Prop({ default: 0 }) numberOfTeamMembers!: number;

  @Prop({ default: 0 }) numberOfTickets!: number;
}
